"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfComparableSaleDto = instanceOfComparableSaleDto;
exports.ComparableSaleDtoFromJSON = ComparableSaleDtoFromJSON;
exports.ComparableSaleDtoFromJSONTyped = ComparableSaleDtoFromJSONTyped;
exports.ComparableSaleDtoToJSON = ComparableSaleDtoToJSON;
exports.ComparableSaleDtoToJSONTyped = ComparableSaleDtoToJSONTyped;
/**
 * Check if a given object implements the ComparableSaleDto interface.
 */
function instanceOfComparableSaleDto(value) {
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('date' in value) || value['date'] === undefined)
        return false;
    return true;
}
function ComparableSaleDtoFromJSON(json) {
    return ComparableSaleDtoFromJSONTyped(json, false);
}
function ComparableSaleDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'address': json['address'],
        'price': json['price'],
        'date': json['date'],
        'bedrooms': json['bedrooms'] == null ? undefined : json['bedrooms'],
        'propertyType': json['propertyType'] == null ? undefined : json['propertyType'],
        'bathrooms': json['bathrooms'] == null ? undefined : json['bathrooms'],
        'landArea': json['landArea'] == null ? undefined : json['landArea'],
        'distance': json['distance'] == null ? undefined : json['distance'],
    };
}
function ComparableSaleDtoToJSON(json) {
    return ComparableSaleDtoToJSONTyped(json, false);
}
function ComparableSaleDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'address': value['address'],
        'price': value['price'],
        'date': value['date'],
        'bedrooms': value['bedrooms'],
        'propertyType': value['propertyType'],
        'bathrooms': value['bathrooms'],
        'landArea': value['landArea'],
        'distance': value['distance'],
    };
}
